import React, { forwardRef } from 'react';

import MUITableRow, {
  TableRowProps as MUITableRowProps,
} from '@material-ui/core/TableRow';

export interface TableRowProps extends MUITableRowProps {}

const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  (props, ref) => {
    return <MUITableRow {...props} ref={ref} />;
  }
);

export default TableRow;
